export const extraSmall = 450;
export const small = 768;
export const medium = 1280;
export const large = 1600;
export const largest = 1920;
